/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseBillingRequest } from '../../models/course-billing-request';

export interface ApiRequestCndnInitialApplicationGet$Params {
  id?: string;
}

export function apiRequestCndnInitialApplicationGet(http: HttpClient, rootUrl: string, params?: ApiRequestCndnInitialApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseBillingRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCndnInitialApplicationGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseBillingRequest>;
    })
  );
}

apiRequestCndnInitialApplicationGet.PATH = '/api/Request/Cndn/InitialApplication';
